/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback, useContext, useEffect, useState } from 'react';
import RestartAlt from '@mui/icons-material/RestartAlt';
import Tooltip from '@mui/material/Tooltip';
import { Input } from 'antd';
import { formatCustomDate } from '../../helpers/formatCustomDate';
import GeneralCustomTable from '../../helpers/GeneralCustomTable';
import { useForm } from 'react-hook-form';
import LogicContext from '../../Context/LogicContext';
import { toLowercaseKeys } from '../../helpers/toLowerCaseKeys';
// import PermissionModuleFilter from './PermissionModuleFilter';
import { permissionProfileService } from '../../services/permissionProfile.service';
import { SetPermissionProfileAssignToUserAtom , GetPermissionProfileAssignToUserAtom} from '../../store/permissionProfileAssAtom';

const { Search } = Input;

function MenuAssignToUserListPage() {
  const { pathname } = useLocation();
  const logicContext = useContext(LogicContext);
  const navigate = useNavigate();
  const  setProfileAssignToUserAtom = SetPermissionProfileAssignToUserAtom();
  const  getProfileAssignToUserAtom = GetPermissionProfileAssignToUserAtom();

  const url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  const [filteredData, setFilteredData] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);

  const {
    handleSubmit,
    formState: { errors },
  } = useForm();




  useEffect(() => {
    document.title = 'Profile Assign To User';
    if(!getProfileAssignToUserAtom.user_info.length){
      loadTableList();
    }
  }, []);



  useEffect(() => {
    if (sessionStorage.getItem('reloadPage') === 'true') {
      sessionStorage.removeItem('reloadPage');
      reloadData();
    }
  }, []);



  const reloadData = useCallback(() => {
    loadTableList();
  }, []);



  const loadTableList = useCallback(() => {
    permissionProfileService.profileAssignToUserList().then((res) => {
        const serverData = toLowercaseKeys(res.data);
        console.log('Profile assing to user ', serverData);

      if (serverData) {
        setProfileAssignToUserAtom(serverData);
      }
    });
  }, []);



  useEffect(() => {
    if (Array.isArray(getProfileAssignToUserAtom.module) && getProfileAssignToUserAtom.module.length > 0) {
      const allModule = getProfileAssignToUserAtom.module.find((m) => m.module_id === 0);
      setSelectedModule(allModule || null);
    }
  }, [getProfileAssignToUserAtom.module]);



  useEffect(() => {
    if (!Array.isArray(getProfileAssignToUserAtom.user_info)) return;

    if (!selectedModule || selectedModule.module_id === 0) {
      setFilteredData(getProfileAssignToUserAtom.user_info);
      return;
    }

    const filtered = getProfileAssignToUserAtom.user_info.filter(
      (item) => item.module_id === selectedModule.module_id
    );

    setFilteredData(filtered);
  }, [getProfileAssignToUserAtom.user_info, selectedModule]);




  const handleRowClick = useCallback(
    (record) => {
      navigate(
        `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${record?.user_id}`
      );
    },
    [navigate, currModuleId, currModuleName, currUserMenu]
  );



  const onModuleSelect = (module) => {
    setSelectedModule(module);
  };

  const columns = [
    {
      title: 'User ID',
      dataIndex: 'user_id',
      sorter: (a, b) => (a?.user_id ?? 0) - (b?.user_id ?? 0),
    },
    {
      title: 'Full Name',
      dataIndex: 'user_full_name',
      className: 'text-primary',
      sorter: (a, b) =>
        (a?.user_full_name ?? '').localeCompare(b?.user_full_name ?? ''),
    },
    {
      title: 'Group',
      dataIndex: 'user_group_name',
      sorter: (a, b) =>
        (a?.user_group_name ?? '').localeCompare(b?.user_group_name ?? ''),
    },
    {
      title: 'Mobile Number',
      dataIndex: 'user_mobile_number',
      sorter: (a, b) =>
        (a?.user_mobile_number ?? '').localeCompare(b?.user_mobile_number ?? ''),
    },
    {
      title: 'Status',
      dataIndex: 'user_status_name',
      sorter: (a, b) =>
        (a?.user_status_name ?? '').localeCompare(
          b?.user_status_name ?? ''
        ),
    },
 
  ];

  return (
    <>
      <section className="mt-8 px-6">
        <div className="flex items-center justify-between mb-4 bg-gray-50 rounded-lg shadow-sm p-4">
          <Tooltip title="Reload">
            <RestartAlt
              className="cursor-pointer text-blue-600 hover:text-blue-800 h-10 w-10 p-1"
              onClick={reloadData}
            />
          </Tooltip>
          <h4 className="text-xl font-semibold">Menu Assign To User</h4>

        
        </div>

        {/* <div className="flex items-center gap-4">
          <PermissionModuleFilter
            moduleMenuList={getProfileAtom.module}
            onModuleSelect={onModuleSelect}
            defaultVal={0} 
          />
        </div> */}
      </section>

      <section className="mt-5 w-full">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={filteredData}
          allowCheckBox={true}
          rowKey={(record) => record.ref_no}
          handleRowClick={handleRowClick}
        />
      </section>
    </>
  );
}

export default MenuAssignToUserListPage;
